import React from 'react';
import { format, getDay, getHours, isSameWeek } from 'date-fns';
import { useOnInterval } from '../../../calendar-utils';
import { getCurrentDayPosition, WCS } from '../../week-utils';
import getDaysArray from '../../../../../../lib/utils/get-days-array';
import { ObservedSize, TWeekStart } from '../../../calendars';

const DEFAULT_OFFSET = WCS.timeLineWidth;

function getDayIndex(date: Date | number, weekStartsOn: 0 | 1 | 2 | 3 | 4 | 5 | 6) {
  const day = getDay(date);
  return getDaysArray<number>(weekStartsOn).findIndex((d) => d === day);
}

interface DayProgressProps {
  minHour: number;
  maxHour: number;
  weekStartDate: string;
  calendarDims?: ObservedSize;
  weekStartsOn: TWeekStart;
}

const DayProgress: React.FunctionComponent<DayProgressProps> = ({
  minHour,
  maxHour,
  calendarDims,
  weekStartDate,
  weekStartsOn,
}) => {
  /**
   * Show day info only when same week, so today is displayed
   */
  const showInfo = isSameWeek(Date.now(), new Date(weekStartDate), {
    weekStartsOn,
  });

  const [dayPosition, setDayPosition] = React.useState(() =>
    getCurrentDayPosition({
      from: new Date(),
      to: new Date(),
      minHour: minHour,
    }),
  );

  const tickCallback = React.useCallback(
    (cancelCb: Function) => {
      if (getHours(Date.now()) <= maxHour && showInfo) {
        setDayPosition(
          getCurrentDayPosition({
            from: new Date(),
            to: new Date(),
            minHour,
          }),
        );
      } else {
        cancelCb();
      }
    },
    [maxHour, minHour, showInfo],
  );

  useOnInterval(60000, tickCallback);

  if (!showInfo || !dayPosition) {
    return null;
  }

  return (
    <div
      style={{
        top: dayPosition.top - 6 + WCS.gridPadding,
      }}
      className="day-progress"
    >
      <div className="time">{format(Date.now(), 'HH:mm')}</div>
      <div className="line" />
    </div>
  );
};

export default React.memo(DayProgress);
